module.exports = __webpack_public_path__ + "static/deerpark-care-2a3f9b2ee83416afb46fb7cb35d247ce.jpg";